export const WIZUALIZACJE = "/api/doppio/creations";
export const ZAKODOWANE = "/api/doppio/coded"